<template>
    <v-card class="pa-3">
        <h2 class="pb-2">Mês: {{mesAtual}}</h2>
        <v-layout row wrap>
            <v-flex xs12 mb-2>
                <v-sheet >

                    <v-calendar
                    style="min-height:500px;"
                    :now="today"
                    :value="today"
                    v-model="today"
                    :end="today"
                    ref="calendar"
                    color="teal"
                    locale="Pt-Br"
                    :short-months="false"
                    :short-weekdays="false"
                    @change="trocaMes($event)"
                    @click:date="listagemDia($event)"
                    @contextmenu:day="listagemEventos($event)"

                    >
                    <template v-slot:day="{ date }">
                        <v-btn small fab style="height:25px; width:25px;position: absolute;top: 0px;right: 0px; box-shadow: none; border: 1px solid #d4d4d4" @click="abreCampanha(date)">
                            <v-icon :size="15">add</v-icon>
                        </v-btn>
                        <template v-for="event in eventsMap[date]" >

                        <v-menu
                            :key="event.createdAt"
                            v-model="event.open"
                            full-width
                            offset-x
                            :close-on-content-click="false"
                        >
                            <template v-slot:activator="{ on }">
                            <div
                                v-if="!event.time"
                                v-ripple
                                :class="`my-event mt-2 ${corStatus(alteraStatusAgendamento(event.status).status)}`"
                                v-on="on"
                                v-html="formatHora(event.date, event.timezone) + ' ' + event.mensagem"
                            ></div>
                            </template>
                            <v-card
                            color="grey lighten-4"
                            min-width="350px"
                            flat
                            >
                            <!--<v-avatar :tile="true" :size="25" :color="corStatus(alteraStatusAgendamento(event.status).status)" style="border-radius: 5px;">
                            </v-avatar>-->
                            <v-toolbar
                                :color="corStatus(alteraStatusAgendamento(event.status).status)"
                                dark
                            >
                                <v-tooltip bottom v-if="+event.status == 0">
                                    <template v-slot:activator="{ on }">
                                        <v-btn  icon @click="editaCampanha(event)" v-on="on">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <span class="body-1">Alterar agendamento</span>
                                </v-tooltip>
                                <v-toolbar-title v-html="event.mensagem"></v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-tooltip bottom v-if="+event.status == 0">
                                    <template v-slot:activator="{ on }">
                                        <v-btn  icon @click="deletaCampanha(event)" v-on="on">
                                            <v-icon>delete</v-icon>
                                        </v-btn>
                                    </template>
                                    <span class="body-1">Cancelar campanha</span>
                                </v-tooltip>


                            </v-toolbar>
                            <v-card-title primary-title style="flex-direction: column" >
                                <h3 class="pt-1">Criado em: {{formatData(event.createdAt, event.timezone)}}</h3>
                                <h3 class="pt-1">Agendado para: {{formatData(event.date, event.timezone)}}</h3>
                                <h3 class="pt-1">Nome do mailing: {{event.templateMailing[0].nome}}</h3>
                                <h3 class="pt-1">Nome da campanha: {{event.nome || 'Campanha sem nome'}}</h3>
                                <h3 class="pt-1">Status:
                                <v-chip
                                :color="corStatus(alteraStatusAgendamento(event.status).status)"
                                text-color="white"
                                >
                                {{alteraStatusAgendamento(event.status).status}}
                                </v-chip>
                                </h3>
                            </v-card-title>
                            <v-card-actions>
                                <v-btn
                                flat
                                color="teal"
                                @click="event.open = !event.open"
                                >
                                Sair
                                </v-btn>
                            </v-card-actions>
                            </v-card>
                        </v-menu>
                        </template>
                    </template>
                    </v-calendar>
                </v-sheet>
            </v-flex>
            <v-flex
            sm4
            xs12
            class="text-sm-left text-xs-center"
            >
            <v-btn color="fundo" @click="$refs.calendar.prev()">
                <v-icon
                dark
                left
                >
                keyboard_arrow_left
                </v-icon>
                Ant
            </v-btn>
            </v-flex>
            <v-flex
            sm4
            xs12
            class="text-xs-center"
            >
            </v-flex>
            <v-flex
            sm4
            xs12
            class="text-sm-right text-xs-center"
            >
            <v-btn color="fundo" @click="$refs.calendar.next()">
                Próx
                <v-icon
                right
                dark
                >
                keyboard_arrow_right
                </v-icon>
            </v-btn>
            </v-flex>
        </v-layout>
        <v-dialog v-model="novaCampanha" max-width="750">
            <nova-campanha
                :novaCampanha.sync="novaCampanha"
                :campanha.sync="campanha"
                :dataInvalida.sync="dataInvalida"
                :data.sync="data"
                @closeModal="novaCampanha = !novaCampanha"

            />
        </v-dialog>
        <v-dialog v-model="alterarAgendamento" max-width="450" >
            <v-card class="pa-3" >
                <h1 class="fonte mb-2">Alterar data de agendamento para:</h1>

                <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="novoAgendamento.novaData"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                        color="teal"
                        v-model="novoAgendamento.novaData"
                        label="Selecione a data"
                        prepend-icon="event"
                        readonly
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-date-picker
                        v-model="novoAgendamento.novaData"
                        scrollable
                        color="fundo"
                        locale="pt-br"
                        :allowed-dates="allowedDates"
                        >
                    <v-spacer></v-spacer>
                    <v-btn flat color="teal" @click="menu = false">Cancelar</v-btn>
                    <v-btn flat color="teal" @click="$refs.menu.save(novoAgendamento.novaData)">OK</v-btn>
                    </v-date-picker>
                </v-menu>

                <v-menu
                    ref="menuHorario"
                    v-model="menu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    :return-value.sync="novoAgendamento.novaHora"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px"
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                        color="teal"
                        v-model="novoAgendamento.novaHora"
                        label="Selecione a hora"
                        prepend-icon="access_time"
                        readonly
                        v-on="on"
                    ></v-text-field>
                    </template>
                    <v-time-picker
                    min="8:00"
                    max="19:00"
                    format="24hr"
                    scrollable
                    color="fundo"
                    :allowed-hours="allowedHoursEdit"
                    :allowed-minutes="allowedMinutesEdit"
                    @click:hour="pegaHora($event)"
                    v-if="menu2"
                    v-model="novoAgendamento.novaHora"
                    full-width
                    @click:minute="$refs.menuHorario.save(novoAgendamento.novaHora)"
                    ></v-time-picker>
                </v-menu>

                <v-btn
                :loading="isLoadingAlteraCampanha"
                :disabled="isLoadingAlteraCampanha "
                color="fundo"
                @click="alteraCampanha"
                block
                large
                round
                >
                Agendar campanha
                <template v-slot:loader>
                    <span class="custom-loader">
                    <v-icon light>cached</v-icon>
                    </span>
                </template>
                </v-btn>
            </v-card>
        </v-dialog>
        <v-dialog v-model="listaEventos" max-width="600">
            <v-card class="pa-3">
                <h1 class="fonte text-uppercase">{{eventos.length ? `Eventos do dia ${formatData(eventos[0].date, eventos[0].timezone)}` : 'Sem eventos no dia'}}</h1>
                <v-expansion-panel>
                    <v-expansion-panel-content
                    v-for="(item,i) in eventos"
                    :key="i"
                    >
                    <template v-slot:header>
                        <div> Nome da campanha: {{!!item.nome ? item.nome : 'Campanha sem nome'}}</div>
                    </template>
                    <v-card>
                        <v-card-text>
                            <h3 class="pt-1">Criado em: {{formatData(item.createdAt, item.timezone)}}</h3>
                            <h3 class="pt-1">Agendado para: {{formatData(item.date, item.timezone)}}</h3>
                            <h3 class="pt-1">Nome do mailing: {{item.templateMailing[0].nome}}</h3>
                            <h3 class="pt-1">Status:
                            <v-chip
                            :color="corStatus(alteraStatusAgendamento(item.status).status)"
                            text-color="white"
                            >
                            {{alteraStatusAgendamento(item.status).status}}
                            </v-chip>
                            </h3>
                        </v-card-text>
                    </v-card>
                    </v-expansion-panel-content>
                </v-expansion-panel>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import moment from 'moment'
import * as helpers from './../../../helpers/helpers'
import makeSlug from './../../../helpers/makeSlug'
import {mapActions, mapGetters} from 'vuex'
import NovaCampanha from './NovaCampanha.vue'
export default {
    components: {
        NovaCampanha,
    },
    data(){
        return{
            novoAgendamento: { },
            menu: false,
            menu2: false,
            dataPicker: false,
            today:  moment(new Date()).format('YYYY-MM-DD'),
            monthSelected: moment(new Date()).format('M'),
            listaEventos: false,
            novaCampanha: false,
            exibeModelo: false,
            menuHora: false,
            mesAtual: '',
            novoEvento: false,
            dataInvalida: false,
            detalhesTemplate: {},
            eventos: [],
            data: '',
            hora: '',
            picker: null,
            horaSelected: null,
            alterarAgendamento:false,
            isLoadingSendCampanha: false,
            isLoadingAlteraCampanha: false,
            campanha: {
                dataInicial: '',
                mensagem: '',
                template: '',
                nome: ''
            },
        }
    },
    computed: {
        ...mapGetters(['getTemplatesCampanha', 'getAgendamentos', 'getChildren']),
        eventsMap () {
            const map = {}
            this.getAgendamentos.forEach(e => (map[moment(e.date).format('YYYY-MM-DD')] = map[moment(e.date).format('YYYY-MM-DD')] || []).push(e))
            return map
        },
        getTabs()
        {
            return (this.tabs) ? this.getChildren.filter( m => this.tabs.find( t => t == m.rota && m.acoes.filter( a => a.status == true ).length > 0 ) ) : []
        },
        dataFormatada()
        {
            return this.novoAgendamento.novaData != '' ? moment(this.novoAgendamento.novaData).format('DD/MM/YYYY') : ''
        }
    },
    methods: {
        ...mapActions(['arquivos_sendCampanha', 'arquivos_getArquivoTemplateCampanha', 'arquivos_getAgendamentos', 'arquivos_cancelaCampanha', 'arquivos_alteraCampanha']),
        convertDataBr (data) {
            return helpers.getDateTimeZoneBR(data)
        },
        pegaHora(evento)
        {
            this.horaSelected = +evento
        },
        allowedDates(val) {
            //console.log(moment(this.novoAgendamento.date).format('YYYY-MM-DD'))

            return val >= moment(new Date()).format('YYYY-MM-DD')
        },

        allowedHoursEdit(v)
        {

            //console.log(this.novoAgendamento.novaData == moment(new Date()).format('YYYY-MM-DD'), this.novoAgendamento.novaData, moment(new Date()).format('YYYY-MM-DD'))

            if(this.novoAgendamento.novaData == moment(new Date()).format('YYYY-MM-DD'))
            {
               return v >= new Date().getHours()
            }
            else return v >= 8 && v <= 19

        },
        allowedMinutesEdit(v)
        {

            if(this.novoAgendamento.novaData == moment(new Date()).format('YYYY-MM-DD'))
            {
                if(new Date().getHours() == this.horaSelected)
                    return v >= new Date().getMinutes()
                else return true
            }
            else return true

        },
        async sendCadastroCampanha () {
            this.campanha.dataInicial = this.data + ' ' + this.hora

            this.campanha.dataInicial = moment(this.campanha.dataInicial).toDate()

            //console.log(this.campanha)
            this.isLoadingSendCampanha = true

            let r = await this.arquivos_sendCampanha(this.campanha)
            this.$eventHub.emit('snackBar', { message: r.mensagem })
            this.campanha = {
                dataInicial: '',
                hora: '',
                data: '',
                mensagem: '',
                template: '',
            }
            this.arquivos_getAgendamentos(moment(new Date()).format('MM'))
            Object.assign( this.$data, this.$options.data.apply(this) )
            this.isLoadingSendCampanha = false
            this.novaCampanha = false
        },
        trocaMes(data)
        {
            if(data.end.month != this.monthSelected)
            {
                this.monthSelected = data.end.month
                this.arquivos_getAgendamentos(data.end.month)
                this.mesAtual = helpers.nomeMes(data.end.month )
            }
        },
        formatHora(data, timezone)
        {
            return moment(data).format('LT')
        },
        formatData(data, timezone)
        {
            return moment(data).tz(timezone).format('DD/MM/YYYY')
        },
        alteraStatusAgendamento(status)
        {
            return helpers.getStatusAgendamento(status)
        },
        listagemEventos(data){

            let ev   = []
            let date = ''
            ev = this.getAgendamentos.filter(ag => {
                date = this.formatData(ag.date, ag.timezone)
                if(date.slice(0,2) == data.date.slice(8,10)) return ag
                })

            this.listaEventos = true
            this.eventos = ev
        },
        abreCampanha(data)
        {

            if(data >= moment(new Date()).format('YYYY-MM-DD'))
            {
                this.novaCampanha = true
                this.dataInvalida = false
                this.campanha = {
                    dataInicial: '',
                    mensagem: '',
                    template: '',
                    nome: ''
                }
                this.data = data
            }

            else if(data < moment(new Date()).format('YYYY-MM-DD'))
            {
                this.novaCampanha = true
                this.dataInvalida = true
            }
        },
        editaCampanha(evento)
        {

            this.novoAgendamento = evento
            //this.novoAgendamento.novaData = moment(evento.date).format('DD-MM-YYYY')
            this.alterarAgendamento = true

            this.data = moment(evento.date).format('YYYY-MM-DD')

        },
        async alteraCampanha()
        {
            this.isLoadingAlteraCampanha = true
            let data = this.novoAgendamento.novaData + 'T' + this.novoAgendamento.novaHora + ':00'
            data = moment(data).toDate()
            let result = await this.arquivos_alteraCampanha({date: data, _id: this.novoAgendamento._id})
            if(result.status)
            {
                this.isLoadingAlteraCampanha = false
                this.$eventHub.emit('snackBar', { message: result.mensagem })
                this.alterarAgendamento = false
                this.arquivos_getAgendamentos(this.novoAgendamento.month)
            }
            else
            {
                this.isLoadingAlteraCampanha = false
                this.$eventHub.emit('snackBar', { message: result.mensagem })
            }
        },
        detalhesMailing(id)
        {

            this.detalhesTemplate = this.getTemplatesCampanha.find(t => t._id == id)
            return this.detalhesTemplate
        },
        corStatus(status){
            switch (status) {
                case 'processado':
                    return 'green'
                    break;
                case 'processando':
                    return 'cyan darken-2'
                    break;
                case 'agendado':
                    return 'orange'
                    break;

                default:
                    return 'grey'
                    break;
            }
        },
        listagemDia(evento)
        {
            //console.log(evento)
            sessionStorage.setItem("dia", evento.date)
            for( let position in this.getTabs )
                if(this.getTabs[position].rota == "campanhas" )document.querySelector("#campanha-"+position).children[0].click()
        },

        getSlug (text) {
				return makeSlug(text)
        },

        async deletaCampanha(evento)
        {
            if(confirm('Tem certeza que deseja cancelar essa campanha?'))
            {
                let result = await this.arquivos_cancelaCampanha(evento._id)
                if(result.status)
                {
                    this.$eventHub.emit('snackBar', { message: result.mensagem })
                    this.arquivos_getAgendamentos(evento.month)
                }
                else this.$eventHub.emit('snackBar', { message: result.mensagem })
            }
        },
        pegaHora(evento)
        {
            this.horaSelected = +evento
        },
        allowedHours(v)
        {

            if(this.data == moment(new Date()).format('YYYY-MM-DD'))
            {
               return v >= new Date().getHours()
            }
            else return v >= 8 && v <= 19
            /*console.log('hora', v)
            return v*/

        },
        allowedMinutes(v)
        {

            if(this.data == moment(new Date()).format('YYYY-MM-DD'))
            {
                if(new Date().getHours() == this.horaSelected)
                    return v >= new Date().getMinutes()
                else return true
            }

            else return true
            /*console.log('minuto', v)
            return v*/
        },
    },
    watch: {
        'alterarAgendamento'(){
            if(this.alterarAgendamento == false)
            {
                Object.assign( this.$data, this.$options.data.apply(this) )
            }
        }
    },
    mounted(){
        this.mesAtual = helpers.nomeMes(this.monthSelected)
        this.tabs = this.$route.meta.subroutes
        document.querySelector('.v-calendar-weekly__day.v-present').style.backgroundColor = '#CFD8DC'
    }

}
</script>

<style lang="stylus" scoped>
  .my-event {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    border-radius: 2px;
    background-color: #009688;
    color: #ffffff;

    width: 100%;
    font-size: 12px;
    padding: 5px;
    cursor: pointer;
    margin-bottom: 1px;
  }


</style>





// WEBPACK FOOTER //
// src/components/user/mensagens/Calendario.vue